import { syncCodeValidator } from 'signup-ui-lego-core/validaton/codeValidator';
const getErrorMessage = (_value, error, dataKey) => {
  return `data.${dataKey}.error.${error}`;
};
export const codeValidator = {
  sync: syncCodeValidator,
  getErrorMessage
};